<template>
  <div class="my-page-box">
    <el-dialog title="转签信息" :visible.sync="transferDialogShow" width="30%">
      <el-form :model="transferDialogData" ref="transferForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="转签备注" prop="comments">
          <el-input type="textarea" :rows="3" placeholder="请输入内容" v-model="transferDialogData.comments"></el-input>
        </el-form-item>
        <el-form-item label="转签给" prop="">
          <el-tag v-if="transferDialogData.transferEmployee">{{ transferDialogData.transferEmployee.showMsg }}</el-tag>
        </el-form-item>

        <el-divider></el-divider>

        <el-form-item label="搜索员工" prop="">
          <el-input placeholder="请输入员工姓名" v-model="transferDialogData.searchText">
            <el-button @click="transferSearchEmployee" slot="append" icon="el-icon-search">搜索</el-button>
          </el-input>
        </el-form-item>
        <el-table :data="transferDialogData.searchResult" style="width: 100%" border stripe>
          <el-table-column prop="name" label="姓名"></el-table-column>
          <el-table-column prop="departmentName" label="部门"></el-table-column>
          <el-table-column prop="tel" label="手机号"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="success" @click="transferAddEmployee(scope.row)" size="mini">添加</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="transferDialogShow = false">取 消</el-button>
        <el-button type="primary" @click="transferSubmit">确 定</el-button>
      </div>
    </el-dialog>

    <el-drawer title="详细信息" class="drawer-box" :visible.sync="detailDrawerShow" :with-header="false" size="600px">
      <div class="drawer-head">
        <div class="drawer-title">详细信息</div>
        <button @click="detailDrawerShow = false" class="el-drawer__close-btn"><i class="el-icon-close"></i></button>
      </div>
      <div class="drawer-line"></div>
      <div class="drawer-content">
        <!-- content -->
        <el-row>
          <el-col :span="12">
            <div class="grid-content">
              <h4>员工信息</h4>
              <div class="input-item-box"><span class="input-description">头像：</span>
                <el-image class="image-header" :src="drawerData.employee.headUrl" fit="cover">
                </el-image>
              </div>
              <div class="input-item-box"><span class="input-description">姓名：</span>
                <el-input size="mini"
                          v-model="drawerData.employee.name" :disabled="true" class="input-short"></el-input>
              </div>
              <div class="input-item-box"><span class="input-description">手机：</span>
                <el-input size="mini"
                          v-model="drawerData.employee.tel" :disabled="true" class="input-short"></el-input>
              </div>
              <div class="input-item-box"><span class="input-description">工号：</span>
                <el-input size="mini"
                          v-model="drawerData.employee.workId" :disabled="true" class="input-short"></el-input>
              </div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="grid-content">
              <h4>访客信息</h4>
              <div class="input-item-box"><span class="input-description">头像：</span>
                <el-image class="image-header" :src="drawerData.visitor.headUrl" fit="cover">
                </el-image>
              </div>
              <div class="input-item-box"><span class="input-description">姓名：</span>
                <el-input size="mini"
                          v-model="drawerData.visitor.name" :disabled="true" class="input-short"></el-input>
              </div>
              <div class="input-item-box"><span class="input-description">手机：</span>
                <el-input size="mini"
                          v-model="drawerData.visitor.tel" :disabled="true" class="input-short"></el-input>
              </div>
              <div class="input-item-box"><span class="input-description">公司：</span>
                <el-input size="mini"
                          v-model="drawerData.visitor.company" :disabled="true" class="input-short"></el-input>
              </div>
            </div>

          </el-col>
        </el-row>
        <div class="grid-content">
          <h4>表单信息</h4>
          <div v-for="item in drawerData.formInfo" :key="item.key" class="input-item-box">
            <span class="input-description-long">{{ item.label }}:</span>
            <el-input size="mini" :placeholder="item.value" :disabled="true" class="input-long"></el-input>
          </div>
        </div>

        <div class="grid-content ">
          <h4>访客信息</h4>
          <el-table :data="drawerData.peerList" border stripe size="mini">
            <el-table-column prop="name" label="访客姓名" width="70"></el-table-column>
            <el-table-column prop="tel" label="访客手机" width="100"></el-table-column>
            <el-table-column prop="preCardNo" label="访客卡号" width="70"></el-table-column>
            <el-table-column prop="ic" label="身份证号" v-if="visitorSetting.idCardNo !== 1" width="170">
              <template v-slot="scope">
                {{ scope.row.ic  | icNoFilter}}
              </template>
            </el-table-column>
            <el-table-column prop="nationality" label="访客国籍" v-if="visitorSetting.nationality !== 1 " width="70"></el-table-column>
            <el-table-column prop="company" label="访客公司"></el-table-column>
          </el-table>

        </div>

        <div class="grid-content" v-if="drawerData.copyData.length > 0">
          <h4>抄送列表</h4>
          <div v-for="(item, index) in drawerData.copyData" :key="index" class="input-item-box">
            <span class="input-description-long">抄送人员</span>
            <el-input size="mini" :placeholder="item.employeeName" :disabled="true" class="input-long"></el-input>
          </div>
        </div>

        <PendingTransferInfoView style="margin: 20px"
                                 :transferInfoData="drawerData.transferInfo"></PendingTransferInfoView>
        <PendingProgressView style="margin: 20px" :pendingProgressData="drawerData.approveData"
                             :applyData="selectPending"></PendingProgressView>

      </div>
      <div class="drawer-line"></div>
      <div class="drawer-bottom">
        <el-button size="mini" @click="detailDrawerShow = false">返回</el-button>
      </div>
    </el-drawer>

    <div class="nav">
      <el-radio-group v-model="activeTab">
        <el-radio-button class="nav-item" label="valid" border>有效记录
        </el-radio-button>
        <el-radio-button class="nav-item" label="history" border>过期记录
        </el-radio-button>
      </el-radio-group>
    </div>

    <div class="main-content" v-if="activeTab === 'valid'">
      <el-table :data="tableData" border>
        <el-table-column label="访客姓名" width="120px">
          <template v-slot="scope">
            <span>{{ scope.row.visitor.name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="访客号码" width="120px">
          <template v-slot="scope">
            <span>{{ scope.row.visitor.tel }}</span>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" width="140px">
          <template v-slot="scope">
            <span>{{ scope.row.createTime | timeShowFilter }}</span>
          </template>
        </el-table-column>
        <el-table-column label="申请类型" width="80px">
          <template v-slot="scope">
            <el-tag>{{ scope.row.type | applyTypeFilter }}</el-tag>
          </template>
        </el-table-column>

        <el-table-column label="开始时间" width="140px">
          <template v-slot="scope">
            <span>{{ scope.row.beginDate }} {{ scope.row.beginTime.substring(0, 5) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="结束时间" width="140px">
          <template v-slot="scope">
            <span>{{ scope.row.endDate }} {{ scope.row.endTime.substring(0, 5) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="我的身份">
          <template v-slot="scope">
            <el-tag v-for="item in scope.row.related.split('|')" style="margin: 2px" :key="item">{{
                item | roleFilter
              }}
            </el-tag>
          </template>
        </el-table-column>


        <el-table-column v-if="activeTab === 'valid'" label="操作" width="240px">
          <template v-slot="scope">
            <el-button v-if="scope.row.actionShow" :disabled="!scope.row.actionEnable" type="primary" size="mini"
                       @click="dealAction(scope.row)">{{ scope.row.actionShow }}
            </el-button>
            <el-button v-if="scope.row.canManage" type="warning" size="mini" plain
                       @click="modifyApply(scope.row)">修改
            </el-button>
            <el-button v-if="scope.row.canManage" type="danger" size="mini" plain
                       @click="cancelApplyRow(scope.row)">取消
            </el-button>
          </template>
        </el-table-column>

        <el-table-column label="查看" width="80px">
          <template v-slot="scope">
            <el-button type="primary" size="mini" @click="showDetail(scope.row)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pager">
        <el-pagination layout="prev, pager, next"
                       :total="pagiTotal"
                       :page-size="pagiPageSize"
                       :pager-count="5"
                       :current-page.sync="index"
                       @current-change="handlePagination">
        </el-pagination>
      </div>
    </div>
    <div class="main-content" v-else>
      <ApplyedRecordHistoryView :areaMap="areaMap"></ApplyedRecordHistoryView>
    </div>
  </div>
</template>
<script>

import {cancelApplyByEmployee, getAccompanies, getApproves, getMakeCopies, getTransfers, getValidFinishApplies, transferApply} from "@/api/mobile/mobile-apply-api";
import {mixin_table} from "@/utils/mixin";
import {getEmployeeByBatch, getSearchEmployee} from "@/api/mobile/mobile-employee-api";
import {getVisitorByBatch} from "@/api/mobile/mobile-visitor-api";
import PendingProgressView from "@/pages/visitJobs/comp/PendingProgressView.vue";
import PendingTransferInfoView from "@/pages/visitJobs/comp/PendingTransferInfoView.vue";
import {getFileUrl} from "@/utils/fileUploadUtils";
import {getAreaList} from "@/api/mobile/mobile-area-api";
import AppliedRecordHistoryView from '@/pages/visitJobs/comp/AppliedRecordHistoryView.vue'
import {getInviteVisitorFormSettingWithMobile} from "@/api/mobile/mobile-setting-api";

export default {
  components: {PendingTransferInfoView, PendingProgressView, ApplyedRecordHistoryView: AppliedRecordHistoryView},
  mixins: [mixin_table],
  data() {
    return {
      activeTab: 'valid',
      pendedData: [], // 完成审批

      detailDrawerShow: false,
      employeeMap: {},
      pendingCmd: 'show', // show-查看, approve-审批, endorse-转签

      selectPending: {},
      drawerData: {
        employee: {name: "", tel: "", workId: "",},
        visitor: {name: "", tel: "", company: "",},
        formInfo: [],
        peerList: [],
        approveData: [],  // 审批进度
        copyData: [],     //  抄送列表
        transferInfo: [], // 转签信息
      },

      approveDialogShow: false,

      transferDialogShow: false,
      transferDialogData: {
        comments: "",
        transferEmployee: null,

        searchText: "",
        searchResult: [],
      },
      areaMap: {},
      visitorSetting: {
        idCardNo: 2, // 身份证号设置  1不展示， 2选填， 3必填; 默认选填
        nationality: 1, // 国籍设置  1不展示， 2选填， 3必填； 默认不展示
      },
    };
  },
  mounted() {
    this.loadPageData();
    this.setupAreaData();
    getInviteVisitorFormSettingWithMobile().then(({data}) => {
      console.log("getInviteVisitorFormSettingWithMobile", data)
      if (data.code === 200) {
        data.data.forEach(item => {
          if (item.type === "VISITOR_INVITE") {
            let content = JSON.parse(item.content)
            if (content) {
              this.visitorSetting.idCardNo = content.idCardNo
              this.visitorSetting.nationality = content.nationality
            }
          }
        })
      }
      if (this.visitorSetting.idCardNo === 3) {
        this.visitorRules.ic = [{required: true, message: '请输入身份证号', trigger: 'blur'}]
      }
      if (this.visitorSetting.nationality === 3) {
        this.visitorRules.nationality = [{required: true, message: '请输入国籍', trigger: 'blur'}]
      }
    }).catch((err) => {
      this.showNetErrMsg(err)
    })
  },

  methods: {

    setupAreaData() {
      getAreaList().then(({data}) => {
        if (data.code === 200) {
          this.areaTree = data.data
          this.areaMap = {}
          this.areaTree.forEach(item => {
            this.areaMap[item.id] = item
            ;(item.areas || []).forEach(subItem => {
              this.areaMap[subItem.id] = subItem
            })
          })
        } else {
          this.showServerErrMsg(data.msg)
        }
      }).catch(err => {
        console.log("doGetAllArea err", err)
        this.showNetErrMsg()
      })
    },

    loadPageData() {
      this.tableAllData = []
      this.tableShowData = []
      this.tableData = []

      this.loadPendedData()
    },

    loadPendedData() {
      console.log("loadPendedData => ")
      this.activeTab = 'valid'
      getValidFinishApplies().then(async ({data}) => {
        console.log("getValidFinishApplies => ", data);
        if (data.code === 200) {
          if (data.data == null || data.data.length === 0) {
            this.pendedData = []
            this.updateTableData()
            return
          }
          this.pendedData = data.data;
          let employeeCodes = []
          this.pendedData.forEach(item => {
            this.$set(item, 'currentEmployeeName', "")
            employeeCodes.push(item.currentEmployeeCode)
          })

          let employeeResult = await getEmployeeByBatch(employeeCodes)
          if (employeeResult.data.code === 200) {
            employeeResult.data.data.forEach(item => {
              this.employeeMap[item.code] = item
            })
          }

          let newPendedData = []
          for (let i = 0; i < this.pendedData.length; i++) {
            let item = this.pendedData[i]
            item.currentEmployeeName = this.employeeMap[item.currentEmployeeCode] ? this.employeeMap[item.currentEmployeeCode].name : ""
            let showTransfer = false
            if (item.transferEmployeeId == null && item.employeeId === this.$store.state.employeeLoginInfo.id) {
              showTransfer = true
            } else if (item.transferEmployeeId != null && item.transferEmployeeId === this.$store.state.employeeLoginInfo.id) {
              showTransfer = true
            }
            // 自己的邀约/被访申请（已审批 PASS 且未到访）可取消/修改
            this.$set(item, 'canManage',
                showTransfer && item.state === 'PASS' && item.arrived === 'NO')
            if (showTransfer) {
              if (item.allVisitorLeaved) {
                this.$set(item, 'actionShow', "已签退")
                this.$set(item, 'actionEnable', false)
              } else {
                this.$set(item, 'actionShow', "转签")
                this.$set(item, 'actionEnable', true)
              }
            } else {
              this.$set(item, 'actionShow', '')
              this.$set(item, 'actionEnable', false)
            }
            newPendedData.push(item)
          }
          this.pendedData = newPendedData
          console.log("@@@ pendedData => ", this.pendedData)

        } else {
          this.showServerErrMsg(data.code)
        }
        this.updateTableData()
      }).catch((err) => {
        console.log("getValidPendingApplies => ", err);
        this.showServerErrMsg(err)
        this.updateTableData()
      })
    },

    updateTableData() {
      console.log("updateTableData => second")
      this.tableAllData = []
      this.tableAllData.push(...this.pendedData)
      this.tableShowData = this.tableAllData
      this.initPaginationTable()
    },

    dealAction(row) {
      this.dealTransfersAction(row)
    },

    // 取消自己的预约（已审批 PASS 且未到访）
    cancelApplyRow(row) {
      this.$confirm('确定取消该预约吗？取消后访客将无法凭此预约签到。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '再想想',
        type: 'warning'
      }).then(() => {
        cancelApplyByEmployee({id: row.id, employeeId: this.$store.state.employeeLoginInfo.id}).then(({data}) => {
          if (data.code === 200) {
            this.$message.success("取消成功")
            this.loadPageData()
          } else {
            this.$message.error(data.msg || "取消失败")
          }
        }).catch(err => {
          console.error("cancelApplyByEmployee err", err)
          this.showNetErrMsg(err)
        })
      }).catch(() => {
      })
    },

    // 修改自己的邀约：携带原申请跳到邀请页预填
    modifyApply(row) {
      sessionStorage.setItem('inviteEditApply', JSON.stringify(row))
      this.$router.push({name: 'inviteVisitor'})
    },

    dealTransfersAction(row) {
      this.selectPending = row
      this.transferDialogShow = true
    },

    transferSubmit() {
      if (!this.transferDialogData.transferEmployee) {
        this.$message.warning("请先选择转签人员")
        return
      }
      if (!this.transferDialogData.comments) {
        this.$message.warning("请先填写转签备注信息")
        return
      }
      console.log("transferSubmit => ", this.transferDialogData)

      let transfer = {
        applyId: this.selectPending.id,
        beginDate: this.selectPending.beginDate,
        endDate: this.selectPending.endDate,
        fromEmployeeId: this.$store.state.employeeLoginInfo.id,
        toEmployeeId: this.transferDialogData.transferEmployee.id,
        comments: this.transferDialogData.comments
      }
      console.log("transferApply postData => ", transfer)
      transferApply(transfer).then(({data}) => {
        console.log("transferApply => ", data);
        if (data.code === 200) {
          this.$message.success("转签成功")
          this.transferDialogShow = false
          this.loadPageData()
        } else if (data.code === 730) {
          this.$message.success("您已经完成成功")
        } else {
          this.showServerErrMsg(data.code)
        }
      }).catch((err) => {
        console.log("transferApply => ", err);
        this.showServerErrMsg(err)
      })
    },

    showDetail(row) {
      console.log("showDetail => ", row)
      let employeeHead = require('@/assets/default_header.webp')
      if (row.employee.head) {
        employeeHead = getFileUrl(row.employee.head)
      }
      let visitorHead = require('@/assets/default_header.webp')
      if (row.visitor.head) {
        visitorHead = getFileUrl(row.visitor.head)
      }
      this.drawerData = {
        employee: {name: "", tel: "", workId: "",},
        visitor: {name: "", tel: "", company: "",},
        formInfo: [],
        peerList: [],
        approveData: [],  // 审批进度
        copyData: [],     //  抄送列表
        transferInfo: [], // 转签信息
      }
      this.drawerData.employee = {
        headUrl: employeeHead, name: row.employee.name, tel: row.employee.tel, workId: row.employee.workId,
      }
      this.drawerData.visitor = {
        headUrl: visitorHead, name: row.visitor.name, tel: row.visitor.tel, company: row.visitor.company,
      }
      if (row.visitorCardNo) {
        this.$set(row.visitor, "preCardNo", row.visitorCardNo)
      }
      this.drawerData.peerList.push(row.visitor)
      let showInfo = []
      if (row.entryArea) {
        let area = this.areaMap[row.entryArea]
        let superArea = area ? this.areaMap[area.parentId] : null
        if (area && superArea) {
          showInfo.push({
            label: "到访区域",
            value: superArea.name + "，" + area.name
          })
        }
      }
      if (row.groupName) {
        showInfo.push({label: "团访名称", value: row.groupTel ? row.groupName + "（" + row.groupTel + "）" : row.groupName, key: "groupName"})
      }
      showInfo.push({label: "开始时间", value: row.beginDate + " " + row.beginTime.substring(0, 5), key: "beginTime"})
      showInfo.push({label: "结束时间", value: row.endDate + " " + row.endTime.substring(0, 5), key: "endTime"})
      if (row.forms) {
        row.forms.forEach(item => {
          if (item.name !== "startTime" && item.name !== "endTime" && item.name !== "peer") {
            showInfo.push({label: item.title, value: item.value, key: item.name})
          }
        })

      }
      // 同行人
      let codes = []
      getAccompanies(row.id).then(({data}) => {
        console.log("getAccompanies => ", data);

        if (data.code === 200) {
          data.data.forEach(item => {
            if (!codes.includes(item.visitorCode)) {
              codes.push(item.visitorCode)
            }
          })
        }
        getVisitorByBatch(codes).then(({data}) => {
          if ((data.code === 200) && (data.data != null)) {
            let accompanyCards = row.accompanyCards ? row.accompanyCards : {}
            data.data.forEach(item => item.preCardNo = accompanyCards[item.code])
            this.drawerData.peerList.push(...data.data)
          }
        }).catch((err) => {
          console.log("getVisitorByBatch => ", err);
        })
      }).catch((err) => {
        console.log("getAccompanies => ", err);
      })

      // 审批进度
      getApproves(row.id).then(({data}) => {
        console.log("getApproves => ", data);
        if (data.code === 200) {
          this.drawerData.approveData = data.data

          let newEmployeeCodes = []
          this.drawerData.approveData.forEach(item => {
            if (this.employeeMap[item.employeeCode]) {
              this.$set(item, 'employeeName', this.employeeMap[item.employeeCode].name)
            } else {
              this.$set(item, 'employeeName', "")

              if (!newEmployeeCodes.includes(item.employeeCode)) {
                newEmployeeCodes.push(item.employeeCode)
              }
            }
          })
          if (newEmployeeCodes.length === 0) {
            return
          }
          getEmployeeByBatch(newEmployeeCodes).then(({data}) => {
            console.log("getEmployeeByBatch => ", data);
            if (data.code === 200) {
              data.data.forEach(item => {
                this.employeeMap[item.code] = item
              })
              let newApproveData = []
              this.drawerData.approveData.forEach(item => {
                item.employeeName = this.employeeMap[item.employeeCode] ? this.employeeMap[item.employeeCode].name : ""
                newApproveData.push(item)
              })
              this.drawerData.approveData = newApproveData
            }
          }).catch((err) => {
            console.log("getEmployeeByBatch => ", err);
            this.showServerErrMsg(err)
          })
        }
      }).catch((err) => {
        console.log("getApproves => ", err);
      })


      getMakeCopies(row.id).then(({data}) => {
        console.log("getMakeCopies => ", data);
        if (data.code === 200) {
          this.drawerData.copyData = data.data
          let newEmployeeCodes = []
          this.drawerData.copyData.forEach(item => {
            if (this.employeeMap[item.employeeCode]) {
              this.$set(item, 'employeeName', this.employeeMap[item.employeeCode].name)
            } else {
              this.$set(item, 'employeeName', "")

              if (!newEmployeeCodes.includes(item.employeeCode)) {
                newEmployeeCodes.push(item.employeeCode)
              }
            }
          })
          if (newEmployeeCodes.length === 0) {
            return
          }
          getEmployeeByBatch(newEmployeeCodes).then(({data}) => {
            console.log("getEmployeeByBatch => ", data);
            if (data.code === 200) {
              data.data.forEach(item => {
                this.employeeMap[item.code] = item
              })
              let newCopyData = []
              this.drawerData.copyData.forEach(item => {
                item.employeeName = this.employeeMap[item.employeeCode] ? this.employeeMap[item.employeeCode].name : ""
                newCopyData.push(item)
              })
              this.drawerData.copyData = newCopyData
            }
          }).catch((err) => {
            console.log("getEmployeeByBatch => ", err);
            this.showServerErrMsg(err)
          })
        }
      }).catch((err) => {
        console.log("getMakeCopies => ", err);
      })

      getTransfers(row.id).then(({data}) => {
        console.log("getTransfers => ", data);
        if (data.code === 200) {
          this.drawerData.transferInfo = data.data
          let newEmployeeCodes = []
          this.drawerData.transferInfo.forEach(item => {
            if (item.fromEmployeeCode) {
              if (this.employeeMap[item.fromEmployeeCode]) {
                this.$set(item, 'fromEmployeeName', this.employeeMap[item.fromEmployeeCode].name)
              } else {
                this.$set(item, 'fromEmployeeName', "")

                if (!newEmployeeCodes.includes(item.fromEmployeeCode)) {
                  newEmployeeCodes.push(item.fromEmployeeCode)
                }
              }
            }
            if (item.toEmployeeCode) {
              if (this.employeeMap[item.toEmployeeCode]) {
                this.$set(item, 'toEmployeeName', this.employeeMap[item.toEmployeeCode].name)
              } else {
                this.$set(item, 'toEmployeeName', "")

                if (!newEmployeeCodes.includes(item.toEmployeeCode)) {
                  newEmployeeCodes.push(item.toEmployeeCode)
                }
              }
            }
          })
          if (newEmployeeCodes.length === 0) {
            return
          }
          getEmployeeByBatch(newEmployeeCodes).then(({data}) => {
            console.log("getEmployeeByBatch => ", data);
            if (data.code === 200) {
              data.data.forEach(item => {
                this.employeeMap[item.code] = item
              })
              let newTransferInfo = []
              this.drawerData.transferInfo.forEach(item => {
                if (item.fromEmployeeCode) {
                  item.fromEmployeeName = this.employeeMap[item.fromEmployeeCode] ? this.employeeMap[item.fromEmployeeCode].name : ""
                }
                if (item.toEmployeeCode) {
                  item.toEmployeeName = this.employeeMap[item.toEmployeeCode] ? this.employeeMap[item.toEmployeeCode].name : ""
                }
                newTransferInfo.push(item)
              })
              this.drawerData.transferInfo = newTransferInfo
            }
          }).catch((err) => {
            console.log("getEmployeeByBatch => ", err);
            this.showServerErrMsg(err)
          })
        }
      }).catch((err) => {
        console.log("getTransfers => ", err);
      })

      this.drawerData.formInfo = showInfo
      this.selectPending = row
      this.detailDrawerShow = true
    }, // showDetail end

    transferSearchEmployee() {
      this.transferDialogData.searchResult = []
      if (this.transferDialogData.searchText === "") {
        this.$message.error("请输入员工姓名号")
        return
      }
      console.log("approveSearchEmployee => ", this.transferDialogData.searchText)
      /// this.employeeMap 中 根据手机号过滤员工
      let mapFilterResult = Object.values(this.employeeMap).filter(item => {
        return item.name === this.transferDialogData.searchText
      })

      if (mapFilterResult.length > 0) {
        console.log("approveSearchEmployee => get from cache ", mapFilterResult)
        let employee = mapFilterResult[0]
        this.transferDialogData.searchResult.push({
          ...employee,
          showMsg: `${employee.name} | ${employee.departmentName}`
        })
        return
      }
      let postData = {name: this.transferDialogData.searchText}
      console.log("getSearchEmployee param: ", postData);
      getSearchEmployee(postData).then(({data}) => {
        console.log("getSearchEmployee => ", data);
        if (data.code === 200 && data.data != null && data.data.length > 0) {
          data.data.forEach(item => {
            this.employeeMap[item.code] = item
            this.transferDialogData.searchResult.push({
              ...item,
              showMsg: `${item.name} | ${item.departmentName}`
            })
          })
        } else {
          this.$message.warning("未能找到该员工")
        }
      }).catch((err) => {
        console.log("getSearchEmployee => ", err);
        this.showServerErrMsg(err)
      })

    },

    transferAddEmployee(employee) {
      this.transferDialogData.transferEmployee = employee
    },
  },

  filters: {
    timeShowFilter(value) {
      if (value === null || value.length < 19) {
        return value
      } else {
        return value.substring(0, 10) + " " + value.substring(11, 16)
      }
    },
    applyTypeFilter(value) {
      if (value === "BOOK_APPLY") {
        return "预约"
      } else if (value === "INVITE_APPLY") {
        return "邀约"
      } else {
        return "其他"
      }
    },
    roleFilter(value) {
      if (value === "EMPLOYEE_VISITED") {
        return "被访者"
      } else if (value === "EMPLOYEE_APPROVED") {
        return "审核者"
      } else if (value === "EMPLOYEE_MAKECOPY") {
        return "抄送者"
      } else if (value === "EMPLOYEE_TRANSFER") {
        return "转签者"
      } else {
        return "其他"
      }
    }
  },

  computed: {
    hasCommitPermission() {
      switch (this.$store.state.roleType) {
        case "STAFF":
          return true
        default:
          return false
      }
    }
  },

}
</script>

<style lang="less" scoped>
.nav {
  padding-bottom: 10px;

  .nav-item {
    margin-right: 15px;
  }
}

/deep/ .el-radio-button__inner {
  background-color: #efefef;
}

::v-deep .el-radio-button:first-child .el-radio-button__inner {
  border-radius: 60px;
}

::v-deep .el-radio-button:last-child .el-radio-button__inner {
  border-radius: 60px;
}

.content {
  background-color: white;
}

.main-content {
  background-color: white;

  .tab-title {
    font-weight: 550;
    font-size: 16px;
  }
}

.drawer-content {

  .input-short {
    width: 150px;
  }

  .input-long {
    width: 400px;
  }

  .grid-content {
    margin: 8px 8px 8px 20px;

  }

  .input-item-box {
    display: flex;
    flex-direction: row;
    align-items: start;
    padding-bottom: 8px;
    font-size: 14px;
  }

  .input-description {
    display: inline-block;
    width: 80px;
  }

  .input-description-long {
    display: inline-block;
    width: 120px;
  }

}

.image-header {
  width: 80px;
  height: 100px;
}

.my-page-box {
  padding-left: 10vw;
  padding-right: 10vw;
}
</style>
